import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'm4u-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss']
})
export class IconComponent {
    @Input() Name: string;
    @Input() Size: number = 24;
    @Input() Tip: string;

    @HostBinding('style.width') get width() {
        return `${this.Size}px`;
    }
    @HostBinding('style.height') get height() {
        return `${this.Size}px`;
    }
    @HostBinding('style.line-height') get lineHeight() {
        return `${this.Size}px`;
    }
    @HostBinding('style.font-size') get fontSize() {
        return `${this.Size}px`;
    }
    @HostBinding('style.background-size') get backgroundSize() {
        return `${this.Size}px ${this.Size}px`;
    }

    get isLink() {
        return /\//.test(this.Name);
    }
}
